export const tabStyle = {
  colorBackground: 'white',
  colorMain: "lightseagreen", //#ffa500
  colorText: 'white',
  colorTextAlt: "white", //#ffa500 //lightseagreen
  colorHover: "#2c9993", //"#0c7983", //#e69d17 //#2c9993
};

export const tabStyleSecondary = {
  colorBackground: '#f7f7f7',
  colorMain: "rgb(245, 255, 245)",
  colorText: 'white',
  colorTextAlt: "#458B00",
  colorHover: "#458B00",
};

// export const tabStyleSecondary = {
//   colorBackground: '#f7f7f7',
//   colorMain: "#75c7f0",
//   colorText: 'black',
//   colorTextAlt: "#3a87ad",
//   colorHover: "#3a87ad",
// };
